<ng-container *ngIf="state$ | async as state">
  <button
    *appHasPermission="'referral.view'"
    mat-icon-button
    [matTooltip]="'icons.referrals.tooltip' | translate: { status: state.tooltipText | translate }"
    matTooltipPosition="above"
    [matMenuTriggerFor]="referralMenu"
    [disabled]="state.insuranceItems.length === 0"
    (click)="$event.stopPropagation()"
  >
    <div class="icon-container">
      <mmx-overlap-icon
        *ngIf="state.statuses"
        [primaryColor]="state.statuses.primary"
        [secondaryColor]="state.statuses.secondary"
        icon="person_add"
      ></mmx-overlap-icon>
    </div>
  </button>

  <mat-menu #referralMenu="matMenu">
    <button
      *ngFor="let item of state.insuranceItems"
      mat-menu-item
      class="icon-menu-item"
      (click)="openConfirmDialog(item.insurance, item.status)"
    >
      <mat-icon
        class="primary-icon"
        [ngClass]="item.statusColor"
      >
        person_add
      </mat-icon>
      {{ item.insurance.typeText | translate }} - {{ item.insurance.clinicCarrierName }}
      ({{ (item.status ? 'statuses.referrals.' + item.status : 'common.unknown') | translate }})
    </button>
  </mat-menu>
</ng-container>
